import { AwardsStep } from "../components/raffle/create/steps/awardsStep";
import { BankAccountSteps } from "../components/raffle/create/steps/bankAccountsStep";
import { MainFeaturesStep } from "../components/raffle/create/steps/mainFeaturesStep";
import { SummaryRaffleStep } from "../components/raffle/create/steps/summaryRaffleStep";

export const STEPS = [
    {
      label: 'Caracteristicas principales',
      component: MainFeaturesStep
    },
    {
      label: 'Premios',
      component: AwardsStep
    },
    {
      label: 'Cuentas bancarías',
      component: BankAccountSteps
    },
    {
      label: 'Resumen de la rifa',
      component: SummaryRaffleStep
    },
  ];
